import { Link } from "@inertiajs/react"
import { ArrowRight } from "lucide-react"

import { getRelatedTools } from "@/lib/tool-relationships"

interface Props {
  currentTool: string
}

export function RelatedTools({ currentTool }: Props) {
  const relatedTools = getRelatedTools(currentTool)

  if (relatedTools.length === 0) return null

  return (
    <section className="mt-16 border-t pt-8">
      <h2 className="text-lg font-semibold">Related Tools</h2>
      <div className="mt-4 grid gap-4 sm:grid-cols-2">
        {relatedTools.map((tool) => (
          <Link
            key={tool.slug}
            href={tool.href}
            className="group hover:bg-muted flex items-center justify-between rounded-lg border p-4 transition-colors"
          >
            <div>
              <p className="font-medium">{tool.name}</p>
              <p className="text-muted-foreground text-sm">
                {tool.description}
              </p>
            </div>
            <ArrowRight className="text-muted-foreground h-4 w-4 transition-transform group-hover:translate-x-1" />
          </Link>
        ))}
      </div>
    </section>
  )
}
